<template>
  <div
    style="
      position: relative;
      display: flex;
      flex-direction: column;
      background-color: #2441bf;
      height: 100%;
      overflow: hidden;
    "
  >
    <div style="flex: 1; overflow: hidden; position: relative">
      <li
        v-if="$window.apiUrl.includes('192.168')"
        style="
          position: absolute;
          left: 5px;
          top: 5px;
          color: #fff;
          z-index: 999;
          font-size: 80%;
        "
      >
        开发版
      </li>
      <el-menu
        :default-active="$store.state.navData[$store.state.navIndex]?.path"
        :collapse="props.hideMenu"
        style="
          overflow: overlay;
          overflow-x: hidden;
          border-right: 0;
          color: #fff;
          height: 100%;
          max-width: 200px;
        "
        backgroundColor="#2441bf"
        textColor="#fff"
        activeTextColor="#fff"
        class="menu-box"
        :class="props.hideMenu ? 'min-menu-box' : ''"
        popperClass="menu-box"
      >
        <div
          style="
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 200px;
            border-bottom: 1px solid #a2a2a2;
            overflow: hidden;
          "
          v-if="!props.hideMenu"
        >
          <el-image
            :src="require('@/assets/images/logo.png')"
            style="width: 70%; margin: auto"
            fit="contain"
          ></el-image>
        </div>
        <div
          style="
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #a2a2a2;
          "
          v-else
        >
          <el-image
            :src="require('@/assets/images/logo_x.png')"
            style="width: 40px; margin: 10px"
            fit="contain"
          ></el-image>
        </div>
        <el-menu-item index="HomeMain" @click="onMenuClick('HomeMain', '首页')">
          <el-icon :size="state.menuIconSize"><House /></el-icon>
          <template #title>
            <span class="firstMenu">首页</span>
          </template>
        </el-menu-item>
        <el-sub-menu
          index="2"
          v-if="$judge_auth(['2', '10', '16', '20', '28', '32'])"
        >
          <template #title>
            <el-icon :size="state.menuIconSize"><Present /></el-icon>
            <span class="firstMenu">员工管理</span>
          </template>
          <el-menu-item
            index="EmployeeList"
            class="secondMenu"
            @click="onMenuClick('EmployeeList', '员工花名册')"
            v-if="$judge_auth('2')"
          >
            员工花名册
          </el-menu-item>
          <el-menu-item
            index="EmployeeDeclareList"
            class="secondMenu"
            @click="onMenuClick('EmployeeDeclareList', '员工报送')"
            v-if="$judge_auth('10')"
          >
            员工报送
          </el-menu-item>
          <el-menu-item
            index="DeductionAmountList"
            class="secondMenu"
            @click="onMenuClick('DeductionAmountList', '减除费用扣除确认')"
            v-if="$judge_auth('16')"
          >
            减除费用扣除确认
          </el-menu-item>
          <el-menu-item
            index="EssentialList"
            class="secondMenu"
            @click="onMenuClick('EssentialList', '专项附加扣除管理')"
            v-if="$judge_auth('20')"
          >
            专项附加扣除管理
          </el-menu-item>
          <el-menu-item
            index="PersonalPensionList"
            class="secondMenu"
            @click="onMenuClick('PersonalPensionList', '个人养老金扣除')"
            v-if="$judge_auth('28')"
          >
            个人养老金扣除
          </el-menu-item>
          <el-menu-item
            index="TaxBureauList"
            class="secondMenu"
            @click="onMenuClick('TaxBureauList', '公积金专区')"
            v-if="$judge_auth('32')"
          >
            公积金专区
          </el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="3" v-if="$judge_auth(['36', '39', '44'])">
          <template #title>
            <el-icon :size="state.menuIconSize"><Tickets /></el-icon>
            <span class="firstMenu">客户管理</span>
          </template>
          <el-menu-item
            index="CustomerPoolList"
            class="secondMenu"
            @click="onMenuClick('CustomerPoolList', '客户池')"
            v-if="$judge_auth('36')"
          >
            客户池
          </el-menu-item>
          <el-menu-item
            index="CustomerMyList"
            class="secondMenu"
            @click="onMenuClick('CustomerMineList', '我的客户')"
            v-if="$judge_auth('39')"
          >
            我的客户
          </el-menu-item>
          <el-menu-item
            index="CustomerList"
            class="secondMenu"
            @click="onMenuClick('CustomerList', '客户管理')"
            v-if="$judge_auth('44')"
          >
            客户管理
          </el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="4" v-if="$judge_auth(['50', '55', '58'])">
          <template #title>
            <el-icon :size="state.menuIconSize"><ChatDotSquare /></el-icon>
            <span class="firstMenu">供应商</span>
          </template>
          <el-menu-item
            index="SupplierList"
            class="secondMenu"
            @click="onMenuClick('SupplierList', '供应商档案')"
            v-if="$judge_auth('50')"
          >
            供应商档案
          </el-menu-item>
          <el-menu-item
            index="CalcTaxOutsourceList"
            class="secondMenu"
            @click="onMenuClick('CalcTaxOutsourceList', '外协算税')"
            v-if="$judge_auth('55')"
          >
            外协算税
          </el-menu-item>
          <el-menu-item
            index="SalaryPaymentOutsourceList"
            class="secondMenu"
            @click="onMenuClick('SalaryPaymentOutsourceList', '外协工资发放')"
            v-if="$judge_auth('58')"
          >
            外协工资发放
          </el-menu-item>
        </el-sub-menu>
        <el-sub-menu
          index="5"
          v-if="$judge_auth(['62', '67', '70', '75', '82', '393', '90', '94'])"
        >
          <template #title>
            <el-icon :size="state.menuIconSize"><Money /></el-icon>
            <span class="firstMenu">个税管理</span>
          </template>
          <el-menu-item
            index="WithholdingAgentList"
            class="secondMenu"
            @click="onMenuClick('WithholdingAgentList', '扣缴义务人管理')"
            v-if="$judge_auth('62')"
          >
            扣缴义务人管理
          </el-menu-item>
          <el-menu-item
            index="CalcTaxList"
            class="secondMenu"
            @click="onMenuClick('CalcTaxList', '算税记录')"
            v-if="$judge_auth('67')"
          >
            算税记录
          </el-menu-item>
          <el-menu-item
            index="UnCalcTaxEmployeeList"
            class="secondMenu"
            @click="onMenuClick('UnCalcTaxEmployeeList', '未算税员工')"
            v-if="$judge_auth('562')"
          >
            未算税员工
          </el-menu-item>
          <el-menu-item
            index="ContractUnitList"
            class="secondMenu"
            @click="onMenuClick('ContractUnitList', '签约单位')"
            v-if="$judge_auth('70')"
          >
            签约单位
          </el-menu-item>
          <el-menu-item
            index="TaxDeclareList"
            class="secondMenu"
            @click="onMenuClick('TaxDeclareList', '个税申报')"
            v-if="$judge_auth('75')"
          >
            个税申报
          </el-menu-item>
          <el-menu-item
            index="TaxPayList"
            class="secondMenu"
            @click="onMenuClick('TaxPayList', '税款缴纳')"
            v-if="$judge_auth('82')"
          >
            税款缴纳
          </el-menu-item>
          <el-menu-item
            index="TaxDeclareEmployeeList"
            class="secondMenu"
            @click="onMenuClick('TaxDeclareEmployeeList', '核算明细')"
            v-if="$judge_auth('393')"
          >
            核算明细
          </el-menu-item>
          <el-menu-item
            index="PtsMessageList"
            class="secondMenu"
            @click="onMenuClick('PtsMessageList', '申诉管理')"
            v-if="$judge_auth('90')"
          >
            申诉管理
          </el-menu-item>
          <el-menu-item
            index="PtsCommissionList"
            class="secondMenu"
            @click="onMenuClick('PtsCommissionList', '退付手续费')"
            v-if="$judge_auth('94')"
          >
            退付手续费
          </el-menu-item>
          <el-menu-item
            index="ReCalcTaxEmployeeList"
            class="secondMenu"
            @click="onMenuClick('ReCalcTaxEmployeeList', '复核算税')"
            v-if="$judge_auth('568')"
          >
            复核算税
          </el-menu-item>
          <el-menu-item
            index="TaxDeclareCorrectList"
            class="secondMenu"
            @click="onMenuClick('TaxDeclareCorrectList', '工资更正单')"
            v-if="$judge_auth('614')"
          >
            工资更正单
          </el-menu-item>
        </el-sub-menu>
        <el-sub-menu
          index="6"
          v-if="$judge_auth(['102', '107', '110', '113', '115', '118'])"
        >
          <template #title>
            <el-icon :size="state.menuIconSize"><CreditCard /></el-icon>
            <span class="firstMenu">发薪管理</span>
          </template>
          <el-menu-item
            index="PayrollList"
            class="secondMenu"
            @click="onMenuClick('PayrollList', '工资表')"
            v-if="$judge_auth('102')"
          >
            工资表
          </el-menu-item>
          <el-menu-item
            index="BankCollectedList"
            class="secondMenu"
            @click="onMenuClick('BankCollectedList', '到款查询')"
            v-if="$judge_auth('107')"
          >
            到款查询
          </el-menu-item>
          <el-menu-item
            index="SalaryApplyList"
            class="secondMenu"
            @click="onMenuClick('SalaryApplyList', '发薪审核')"
            v-if="$judge_auth('110')"
          >
            发薪审核
          </el-menu-item>
          <el-menu-item
            index="SalaryRecordList"
            class="secondMenu"
            @click="onMenuClick('SalaryRecordList', '发薪查询')"
            v-if="$judge_auth('113')"
          >
            发薪查询
          </el-menu-item>
          <el-menu-item
            index="InvoiceApplyList"
            class="secondMenu"
            @click="onMenuClick('InvoiceApplyList', '申请开票')"
            v-if="$judge_auth('115')"
          >
            申请开票
          </el-menu-item>
          <el-menu-item
            index="BankCollectedOther"
            class="secondMenu"
            @click="onMenuClick('BankCollectedOther', '认领记录')"
            v-if="$judge_auth('118')"
          >
            认领记录
          </el-menu-item>
        </el-sub-menu>
        <el-sub-menu
          index="7"
          v-if="$judge_auth(['120', '125', '130', '133', '135', '138'])"
        >
          <template #title>
            <el-icon :size="state.menuIconSize"><Coin /></el-icon>
            <span class="firstMenu">财务管理</span>
          </template>
          <el-menu-item
            index="BankAccountList"
            class="secondMenu"
            @click="onMenuClick('BankAccountList', '银行账户')"
            v-if="$judge_auth('120')"
          >
            银行账户
          </el-menu-item>
          <el-menu-item
            index="BankReceivedList"
            class="secondMenu"
            @click="onMenuClick('BankReceivedList', '银行到账')"
            v-if="$judge_auth('125')"
          >
            银行到账
          </el-menu-item>
          <el-menu-item
            index="BankReceivedMergeList"
            class="secondMenu"
            @click="onMenuClick('BankReceivedMergeList', '到账合并')"
            v-if="$judge_auth('730')"
          >
            到账合并
          </el-menu-item>
          <el-menu-item
            index="SalaryPaymentList"
            class="secondMenu"
            @click="onMenuClick('SalaryPaymentList', '薪酬发放')"
            v-if="$judge_auth('130')"
          >
            薪酬发放
          </el-menu-item>
          <el-menu-item
            index="CustomerReceivableMoney"
            class="secondMenu"
            @click="onMenuClick('CustomerReceivableMoney', '应收账款')"
            v-if="$judge_auth('133')"
          >
            应收账款
          </el-menu-item>
          <el-menu-item
            index="DiffBankList"
            class="secondMenu"
            @click="onMenuClick('DiffBankList', '异卡发放审核')"
            v-if="$judge_auth('135')"
          >
            异卡发放审核
          </el-menu-item>
          <el-menu-item
            index="SalaryRecordEmployeeList"
            class="secondMenu"
            @click="onMenuClick('SalaryRecordEmployeeList', '工资发放明细表')"
            v-if="$judge_auth('138')"
          >
            工资发放明细表
          </el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="8" v-if="$judge_auth(['574', '609'])">
          <template #title>
            <el-icon :size="state.menuIconSize"><Operation /></el-icon>
            <span class="firstMenu">报表管理</span>
          </template>
          <el-menu-item
            index="TaxDeclareReportList"
            class="secondMenu"
            @click="onMenuClick('TaxDeclareReportList', '企业申报报表')"
            v-if="$judge_auth('574')"
          >
            企业申报报表
          </el-menu-item>
          <el-menu-item
            index="TaxDeclareReportEmployeeList"
            class="secondMenu"
            @click="
              onMenuClick('TaxDeclareReportEmployeeList', '个人申报明细报表')
            "
            v-if="$judge_auth('609')"
          >
            个人申报明细报表
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item
          index="InvoiceList"
          @click="onMenuClick('InvoiceList', '发票管理')"
          v-if="$judge_auth('142')"
        >
          <el-icon><Tickets /></el-icon>
          <span>发票管理</span>
        </el-menu-item>
        <el-sub-menu
          index="9"
          v-if="$judge_auth(['146', '152', '159', '166', '172', '177'])"
        >
          <template #title>
            <el-icon :size="state.menuIconSize"><Tools /></el-icon>
            <span class="firstMenu">系统管理</span>
          </template>
          <el-menu-item
            index="DepartmentList"
            class="secondMenu"
            @click="onMenuClick('DepartmentList', '部门管理')"
            v-if="$judge_auth('146')"
          >
            部门管理
          </el-menu-item>
          <el-menu-item
            index="AdminRoleList"
            class="secondMenu"
            @click="onMenuClick('AdminRoleList', '角色管理')"
            v-if="$judge_auth('152')"
          >
            角色管理
          </el-menu-item>
          <el-menu-item
            index="AdminList"
            class="secondMenu"
            @click="onMenuClick('AdminList', '用户管理')"
            v-if="$judge_auth('159')"
          >
            用户管理
          </el-menu-item>
          <el-menu-item
            index="DictionaryList"
            class="secondMenu"
            @click="onMenuClick('DictionaryList', '数据字典')"
            v-if="$judge_auth('166')"
          >
            数据字典
          </el-menu-item>
          <el-menu-item
            index="AdminNoticeList"
            class="secondMenu"
            @click="onMenuClick('AdminNoticeList', '通知公告')"
            v-if="$judge_auth('172')"
          >
            通知公告
          </el-menu-item>
          <el-menu-item
            index="LoginLogList"
            class="secondMenu"
            @click="onMenuClick('LoginLogList', '登录日志')"
            v-if="$judge_auth('177')"
          >
            登录日志
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import store from "@/store";
export default {
  props: {
    hideMenu: {
      type: Boolean,
    },
  },
  setup(props) {
    const state = reactive({
      menuIconSize: 18,
    });

    onMounted(() => {});

    const onMenuClick = (path, title) => {
      store.commit("openMenu", { path, title });
    };

    return { state, props, onMenuClick };
  },
};
</script>
<style lang="less">
.firstMenu {
  font-size: 15px;
}

.secondMenu {
  font-size: 14px;
}

.menu-box {
  .el-menu-item.is-active::after {
    content: "";
    background: #3e5ddc !important;
    width: calc(100% - 20px);
    height: 80%;
    position: absolute;
    left: 10px;
    z-index: -1;
    border-radius: 7px;
  }

  & .el-menu-item {
    z-index: 2;
    &:hover {
      background-color: #2441bf !important;
      color: #ffa500;
    }
  }

  & .el-sub-menu > div:first-child {
    position: relative;
    z-index: 9;
    &:hover {
      background-color: #2441bf !important;
      color: #ffa500;
    }
  }
}

.min-menu-box {
  .el-sub-menu.is-active {
    background: #3e5ddc !important;
    margin: 20px;
  }
}
</style>
